import { Box, ColorOptions, Text, TextNew, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { otpStrings } from '../../../data/static/strings'
import { useLazyApiData, useStores } from '../../../data/store'
import { styles } from './styles'

interface CountDownTimerProps {
  count?: number
  mobile?: string
}

const cdtStyles = (resendOtpColor: string) => {
  return {
    resendText: {
      fontSize: 12,
      fontWeight: '700',
      color: resendOtpColor,
    } as TextProps,
  }
}

const getCountDownTime = (cdtimer: number) => {
  return cdtimer > 0 ? (cdtimer < 10 ? `0${cdtimer}` : cdtimer) : ''
}

const CountDownTimer: FC<CountDownTimerProps> = ({ count = 0, mobile }: CountDownTimerProps) => {
  const { generateOtp } = useStores((root) => ({
    generateOtp: root.user.generateOtp,
  }))

  const [countDowntimer, setCountDownTimer] = useState(count)
  const [resendOtp, { data }] = useLazyApiData(generateOtp)
  const error = data?.message ?? ''

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [countDowntimer])

  const resendOtpColor = countDowntimer > 0 ? ('LIGHT_BLACK' as ColorOptions) : ('BLUE' as ColorOptions)

  const onResendOtp = () => {
    if (countDowntimer <= 0) {
      setCountDownTimer(30)
      if (mobile?.length === 10) {
        resendOtp(mobile)
      }
    }
  }

  return (
    <Box testID="resend-otp" onPress={onResendOtp} {...styles.resendTouchable} underlayColor={'TRANSPARENT'}>
      <ModBox show={error?.length > 0}>
        <TextNew type={'bodyMedium14'} color={'ERROR'}>
          {error}
        </TextNew>
      </ModBox>
      <Box {...styles.resendContainer}>
        <Text
          testID={countDowntimer > 0 ? 'resend-otp-disabled' : 'resend-otp-enabled'}
          {...cdtStyles(resendOtpColor).resendText}>
          {otpStrings.resendOtp}
        </Text>
        <Text {...styles.countStyle}>{' ' + getCountDownTime(countDowntimer)}</Text>
        <Text {...styles.secondStyle}>{countDowntimer !== 0 ? 's' : ''}</Text>
      </Box>
    </Box>
  )
}

export default CountDownTimer
